import type * as lazyIndex from './lazyIndex';
import type { PriorityViewBarProps } from './components/PriorityViewBar';
import type { PriorityViewHeaderButtonProps } from './components/PriorityViewHeaderButtons';
import { createLazyComponent, type LazyComponent, LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PriorityInbox"*/ './lazyIndex'),
    { name: 'PriorityInbox' }
);

export const PriorityViewBar: LazyComponent<PriorityViewBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PriorityViewBar);

export const PriorityViewHeaderButtons: LazyComponent<
    PriorityViewHeaderButtonProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.PriorityViewHeaderButtons);

export { shouldShowPrioritizeButton } from './utils/shouldShowPrioritizeButton';
export { shouldUseCustomHighPriorityView } from './utils/shouldUseCustomHighPriorityView';
export { closePriorityView } from './utils/closePriorityView';

export const lazyOpenPriorityView: LazyAction<
    typeof lazyIndex.openPriorityView,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openPriorityView);
